// extracted by mini-css-extract-plugin
module.exports = {"intro":"invoices_intro__3i29u","introtxt":"invoices_introtxt__3pC5V"};